module.exports = __webpack_public_path__ + "img/pic_ys_01.ab1b7cb3.png";